import { useTranslation } from "@/hooks/localization/useTranslations";
import { Col, Row } from "@/utils/bootstrap";

const SocialOr = () => {
  const t = useTranslation();
  return (
    <Row className="mx-0 w-100 social-or" style={{ gap: 16 }}>
      <Col className="p-0 separator"></Col>
      <Col className=" p-0 col-auto or">{t.or}</Col>
      <Col className="p-0 separator"></Col>
    </Row>
  );
};

export default SocialOr;
